import { Component } from '@angular/core';
import { environment } from 'src/environments/environment.dev';
import { AppStatusService } from './@core/services/app-status.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'ctiguard-public';
  isDev: boolean = false;

  constructor(public appStatus: AppStatusService) { }

  ngOnInit(): void {
    this.isDev = !environment.production;
  }

  retry(): void {
    window.location.reload();
  }
}
